import React from "react";
import { Box, Container, Typography } from "@material-ui/core";

interface Props {
  text?: string;
}

const LoadingError: React.FC<Props> = ({ text = "Fehler beim laden" }) => {
  return (
    <Box
      style={{
        backgroundColor: "background.default",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="md">
        <Typography align="center" color="textPrimary" variant="h3">
          Fehler
        </Typography>
        <Typography align="center" color="textPrimary" variant="subtitle2">
          {text}
        </Typography>
        <Box style={{ textAlign: "center" }}>
          <img
            alt="Under development"
            src="/static/images/not_found.png"
            style={{
              marginTop: 50,
              display: "inline-block",
              maxWidth: "100%",
              width: 560,
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default LoadingError;
